import 'animate.css';

export default {
  inserted(el, binding) {
    const animationClass = binding.value || 'animate__fadeInUp';

    // 设置初始不可见（可选）
    el.style.opacity = 0;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('animate__animated', animationClass);
          el.style.opacity = 1; // 还原可见
         el.style.animationDuration = '1.5s';  
          // 触发一次后停止观察
          observer.unobserve(el);
        }
      });
    }, {
      threshold: 0.2 // 元素可见 20% 时触发动画
    });

    observer.observe(el);
  }
};
